import React, { useState } from "react";

import manufactureImg from "../../assets/manufacture.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot, FaIndustry } from "react-icons/fa";

const styles = `
  /* ── HEADER ── */
  .mfg-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .mfg-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .mfg-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .mfg-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .mfg-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .mfg-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .mfg-triangle-left {
    position: absolute;
    left: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .mfg-triangle-right {
    position: absolute;
    right: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .mfg-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .mfg-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  /* ── MAIN ── */
  .mfg-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .mfg-image-wrap {
    flex: 1;
  }

  .mfg-image-wrap img {
    width: 100%;
    max-width: 650px;
  }

  .mfg-accordion {
    flex: 1.2;
  }

  .mfg-accordion-item {
    margin-bottom: 18px;
  }

  .mfg-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #fff;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
  }

  .mfg-accordion-body {
    padding: 20px;
    color: #555;
    line-height: 1.6;
  }

  /* ── TABLET (max-width: 1024px) ── */
  @media (max-width: 1024px) {
    .mfg-header {
      height: auto;
      min-height: 90px;
    }

    .mfg-header-badge {
      width: auto;
      padding: 10px 14px;
      font-size: 14px;
    }

    .mfg-header-title h2 {
      font-size: 22px;
    }

    .mfg-triangle-left,
    .mfg-triangle-right {
      width: 50px;
    }

    .mfg-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── SMALL TABLET / LANDSCAPE MOBILE (max-width: 768px) ── */
  @media (max-width: 768px) {
    .mfg-header {
      flex-direction: column;
      height: auto;
    }

    .mfg-header-left {
      flex: none;
      height: 80px;
      padding: 0 16px;
    }

    .mfg-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
    }

    .mfg-header-right {
      flex: none;
      height: 70px;
      border-top: 1px solid #e5e5e5;
    }

    .mfg-triangle-left,
    .mfg-triangle-right {
      width: 40px;
    }

    .mfg-header-title h2 {
      font-size: 18px;
    }

    .mfg-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .mfg-image-wrap {
      width: 100%;
      text-align: center;
    }

    .mfg-image-wrap img {
      max-width: 100%;
    }

    .mfg-accordion {
      width: 100%;
      flex: none;
    }

    .mfg-accordion-header {
      font-size: 14px;
      padding: 10px 16px;
    }
  }

  /* ── PORTRAIT MOBILE (max-width: 480px) ── */
  @media (max-width: 480px) {
    .mfg-header-left {
      height: 70px;
      padding: 0 12px;
    }

    .mfg-header-badge {
      font-size: 12px;
      padding: 8px 10px;
      gap: 8px;
    }

    .mfg-header-icon-box {
      width: 28px;
      height: 28px;
    }

    .mfg-header-right {
      height: 60px;
    }

    .mfg-header-title h2 {
      font-size: 15px;
    }

    .mfg-triangle-left,
    .mfg-triangle-right {
      width: 28px;
    }

    .mfg-main {
      padding: 20px 14px;
      gap: 24px;
    }

    .mfg-accordion-header {
      font-size: 13px;
      padding: 9px 12px;
    }

    .mfg-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }

    .mfg-accordion-item {
      margin-bottom: 12px;
    }
  }
`;

function ManufacturingPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Material Handling",
      content:
        "AI-powered robotics provide proper handling of materials, test performances, and packing finished products."
    },
    {
      title: "2.AI Application in Quality Control",
      content:
        "AI-powered machines detect defects more accurately than humans."
    },
    {
      title: "3.Estimates device failure",
      content:
        "Predictive maintenance systems help avoid unexpected machine failures."
    },
    {
      title: "4.Digital twins",
      content:
        "Manufacturers can monitor production environments virtually and manage equipment efficiently."
    },
    {
      title: "5.Supply-chain management",
      content:
        "Improves logistics, warehouse systems, and communication across departments."
    },
    {
      title: "6.Customer Management",
      content:
        "Enhances customer experience using CRM tools and AI insights."
    },
    {
      title: "7.Predictive Maintenance",
      content:
        "Uses real-time data to identify and fix issues early."
    },
    {
      title: "8.Robotics",
      content:
        "Reduces human risk and improves automation efficiency."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* HEADER */}
      <div className="mfg-header">

        {/* LEFT */}
        <div
          className="mfg-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="mfg-header-overlay" />

          <div className="mfg-header-badge">
            <div className="mfg-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span style={{ marginLeft: "auto" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="mfg-header-right">
          <div className="mfg-triangle-left" />
          <div className="mfg-triangle-right" />

          <div className="mfg-header-title">
            <FaIndustry style={{ fontSize: "32px", color: "#2fb7a4", flexShrink: 0 }} />
            <h2>Manufacturing</h2>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mfg-main">

        {/* IMAGE */}
        <div className="mfg-image-wrap">
          <img src={manufactureImg} alt="Manufacturing" />
        </div>

        {/* ACCORDION */}
        <div className="mfg-accordion">
          {data.map((item, i) => (
            <div key={i} className="mfg-accordion-item">
              <div
                className="mfg-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "22px"
                  }}
                >
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="mfg-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ManufacturingPage;
